import './MentionsLegales.scss';
import contactInfo from '../contact-info.json';

export function MentionsLegales() {
  return (
    <div className="mentions-legales">
      <div className="container">
        <h1 className="lato-thin">Mentions Légales</h1>

        <section>
          <h2 className="lato-thin">1. Éditeur du site</h2>
          <p>
            <strong>Nom du site :</strong> Lily Massage
          </p>
          <p>
            <strong>Adresse :</strong> {contactInfo.address}
          </p>
          <p>
            <strong>Téléphone :</strong> {contactInfo.phone}
          </p>
          <p>
            <strong>Email :</strong> {contactInfo.email}
          </p>
          <p>
            <strong>Statut :</strong> Auto-entrepreneur
          </p>
          <p>
            <strong>Activité :</strong> Massage bien-être
          </p>
          <p>
            <strong>Numéro SIRET :</strong> 98121347300029
          </p>
        </section>

        <section>
          <h2>2. Hébergement</h2>
          <p>
            <strong>Hébergeur :</strong> Vercel Inc.
          </p>
          <p>
            <strong>Adresse :</strong> 340 S Lemon Ave #4133, Walnut, CA 91789,
            États-Unis
          </p>
          <p>
            <strong>Site web :</strong>{' '}
            <a
              href="https://vercel.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://vercel.com
            </a>
          </p>
        </section>

        <section>
          <h2>3. Propriété intellectuelle</h2>
          <p>
            L&apos;ensemble de ce site relève de la législation française et
            internationale sur le droit d&apos;auteur et la propriété
            intellectuelle. Tous les droits de reproduction sont réservés, y
            compris pour les documents téléchargeables et les représentations
            iconographiques et photographiques.
          </p>
          <p>
            La reproduction de tout ou partie de ce site sur un support
            électronique quel qu&apos;il soit est formellement interdite sauf
            autorisation expresse du directeur de la publication.
          </p>
        </section>

        <section>
          <h2>4. Droits d&apos;auteur des images</h2>
          <p>
            <strong>Images personnelles :</strong> Les photographies prises par
            l&apos;auteur du site sont protégées par le droit d&apos;auteur et
            ne peuvent être utilisées sans autorisation expresse.
          </p>
          <p>
            <strong>Images libres de droit :</strong> Les autres images
            utilisées sur ce site proviennent de banques d&apos;images proposant
            des contenus libres de droit (Unsplash, Pixabay, Pexels) et sont
            utilisées conformément à leurs conditions d&apos;utilisation
            respectives.
          </p>
          <p>
            <strong>Crédits photographiques :</strong> Toutes les images sont
            utilisées dans le respect des droits d&apos;auteur et des licences
            d&apos;utilisation associées. Si vous êtes l&apos;auteur d&apos;une
            image utilisée sur ce site et que vous souhaitez qu&apos;elle soit
            retirée ou que des crédits soient ajoutés, merci de nous contacter à
            l&apos;adresse {contactInfo.email}.
          </p>
        </section>

        <section>
          <h2>5. Protection des données personnelles</h2>
          <p>
            Ce site internet ne collecte aucune donnée personnelle et
            n&apos;utilise aucun cookie de tracking ou d&apos;analyse.
          </p>
          <p>
            Les seules données qui pourraient être collectées sont celles que
            vous choisissez de nous transmettre via le formulaire de contact, et
            ce uniquement dans le but de répondre à votre demande.
          </p>
          <p>
            Conformément à la loi Informatique et Libertés du 6 janvier 1978
            modifiée et au Règlement Général sur la Protection des Données
            (RGPD), vous disposez d&apos;un droit d&apos;accès, de
            rectification, de suppression et d&apos;opposition aux données
            personnelles vous concernant.
          </p>
          <p>
            Pour exercer ces droits, vous pouvez nous contacter à l&apos;adresse
            email suivante : {contactInfo.email}
          </p>
        </section>

        <section>
          <h2>6. Cookies</h2>
          <p>
            Ce site n&apos;utilise aucun cookie de tracking ou d&apos;analyse.
            Seuls des cookies techniques strictement nécessaires au
            fonctionnement du site peuvent être utilisés par la plateforme
            d&apos;hébergement Vercel.
          </p>
        </section>

        <section>
          <h2>7. Responsabilité</h2>
          <p>
            Les informations contenues sur ce site sont aussi précises que
            possible et le site est périodiquement remis à jour, mais peut
            toutefois contenir des inexactitudes, des omissions ou des lacunes.
          </p>
          <p>
            Si vous constatez une lacune, erreur ou ce qui parait être un
            dysfonctionnement, merci de bien vouloir le signaler par email à
            l&apos;adresse {contactInfo.email} en décrivant le problème de la
            manière la plus précise possible.
          </p>
        </section>

        <section>
          <h2>8. Liens hypertextes</h2>
          <p>
            Les liens hypertextes mis en place dans le cadre du présent site
            internet en direction d&apos;autres ressources présentes sur le
            réseau Internet ne sauraient engager la responsabilité de
            l&apos;éditeur du site.
          </p>
        </section>

        <section>
          <h2>9. Droit applicable</h2>
          <p>
            Tout litige en relation avec l&apos;utilisation du site est soumis
            au droit français. En dehors des cas où la loi ne le permet pas, il
            est fait attribution exclusive de juridiction aux tribunaux
            compétents de Paris.
          </p>
        </section>
        <section>
          <h2>10. Facturation</h2>
          <p>
            Conformément à l&apos;arrêté n° 83-50/A du 3 octobre 1983 relatif à
            la publicité des prix, la remise d&apos;une facture est obligatoire
            pour toute prestation d&apos;un montant supérieur à 25 euros.
          </p>
        </section>

        <div className="last-updated">
          <p>
            <strong>Dernière mise à jour :</strong>{' '}
            {new Date().toLocaleDateString('fr-FR')}
          </p>
        </div>
      </div>
    </div>
  );
}
